<template>
  <div>
    <div ref="conteudoRef" class="relatorio-conteudo">
      <div class="pdf-corpo">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

import pdfMake from 'pdfmake/build/pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'

pdfMake.vfs = vfsFonts.vfs

export default {
  props: {
    titulo: {
      type: String,
      default: ''
    },
    subtitulo: {
      type: String,
      default: ''
    },
    revisao: {
      type: String,
      default: ''
    },
    data: {
      type: String,
      default: () => new Date().toLocaleDateString()
    },
    content_top_1: {
      type: Object,
      default: () => ({})
    },
    content_top_2: {
      type: Object,
      default: () => ({})
    },
    content_botton_1: {
      type: Object,
      default: () => ({})
    },
    content_botton_2: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async exportarPdf () {
      const html = this.$refs.conteudoRef
      const htmlContent = html.innerHTML
      const pdfHtmlContent = htmlToPdfmake(htmlContent)

      const docDefinition = {
        pageSize: 'A4',
        pageMargins: [40, 100, 40, 60],
        header: {
          margin: [40, 40, 40, 0],
          columns: [
            { image: this.logoEsquerda, width: 40, height: 40 },
            {
              text: [
                { text: this.subtitulo + '\n', style: 'subtitulo' },
                { text: this.titulo, style: 'titulo' }
              ],
              alignment: 'center',
              width: '*'
            },
            {
              stack: [
                { image: this.logoDireita, width: 100 },
                { text: this.revisao, fontSize: 8 },
                { text: `Data: ${this.data}`, fontSize: 8 }
              ],
              alignment: 'right',
              width: 100
            }
          ]
        },
        footer: (currentPage, pageCount) => {
          const dataHora = new Date().toLocaleString('pt-BR')
          return {
            columns: [
              { text: `Impresso em: ${dataHora}`, alignment: 'left', fontSize: 6 },
              { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', fontSize: 6 }
            ],
            margin: [40, 20, 40, 0]
          }
        },
        content: [
          this.content_top_1,
          this.content_top_1,
          ...pdfHtmlContent,
          this.content_botton_1,
          this.content_botton_2
        ],
        styles: {
          titulo: { fontSize: 12, bold: true },
          subtitulo: { fontSize: 10 }
        }
      }

      pdfMake.createPdf(docDefinition).download('relatorio.pdf')

      this.$emit('close')
    },

    getImageBase64 (src) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.crossOrigin = 'Anonymous'
        img.src = src
        img.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = img.width
          canvas.height = img.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0)
          const dataURL = canvas.toDataURL('image/png')
          resolve(dataURL)
        }
        img.onerror = () => reject(new Error('Erro ao carregar imagem: ' + src))
      })
    }
  },
  data () {
    return {
      logoEsquerda: '',
      logoDireita: ''
    }
  },
  async mounted () {
  },
  async created () {
    this.logoEsquerda = await this.getImageBase64(require('@/assets/report_logo_esquerda.png'))
    this.logoDireita = await this.getImageBase64(require('@/assets/report_logo_direita.jpg'))
    this.$nextTick(() => {
      this.exportarPdf()
    })
  }
}
</script>

<style scoped>
.relatorio-conteudo {
  padding: 15px;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/ReportContainer.vue